var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charging-point-search"},[(_vm.organization && _vm.canSeeCommissionings)?_c('organization-commissionings',{attrs:{"organization-id":_vm.organization.id,"kind":"charging-point"}}):_vm._e(),_c('charging-point-list',{attrs:{"organization-id":_vm.organization.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }